
import { Component, Vue } from "vue-property-decorator";
import NoticiaCardComponent from "@/components/Common/Cards/NoticiaCardComponent.vue";
import NoticiaSliderComponent from "@/components/Common/CarouselSlider/NoticiaSliderComponent.vue";
import BusquedaTramitesCardComponent from "@/components/Common/Cards/BusquedaTramitesCardComponent.vue";
import NoticiaCarouselComponent from "@/components/Common/Carousels/NoticiasCarouselComponent.vue";

interface dataButton {
  id: number | any;
  title?: string;
  uri?: string;
  img?: string;
}

interface dataBanner {
  id: number;
  imagen: string;
  imagen_mobile: string;
  link: string;
}

@Component({
  components: {
    NoticiaCardComponent,
    NoticiaSliderComponent,
    BusquedaTramitesCardComponent,
    NoticiaCarouselComponent
  }
})
export default class Home extends Vue {
  private win = window;
  private slide = 0;
  private aBanners: Array<dataBanner> = [];
  private bannerSlide = 0;
  private slideIndex = 1;
  private bannerTimer: number | null = null;
  private noticias: Array<any> = [];
  private popUp: any = null;
  private verPopUp = false;

  get noticiaDestacada(): any {
    return this.noticias.length > 0 ? this.noticias[0] : null;
  }

  get noticiasParaTarjetas(): Array<any> {
    // Retornar N1, N2, N3 (saltando la destacada que es índice 0)
    // Asumimos que vienen 4 noticias: ND (índice 0), N1 (1), N2 (2), N3 (3)
    return this.noticias.length > 1 ? this.noticias.slice(1, 4) : [];
  }

  private buttons: Array<dataButton> = [
    {
      id: 1,
      title: "EMPLEOS MUNICIPALES",
      uri: "/empleos-municipales"
    },
    {
      id: 2,
      title: "OMIL – OFERTAS LABORALES",
      uri: "https://sites.google.com/view/ofertas-laborales-omil/home"
    },
    {
      id: 3,
      title: "LEY 21.146 DE ORGANIZACIONES COMUNITARIAS",
      uri: "/organizaciones/ley-21146"
    }
    // {
    //   id: 6,
    //   title: "FONDO DE JUVENTUD Y ACCIÓN CLIMÁTICA",
    //   uri: "https://www.municipalidadmaipu.cl/fondo-de-juventud-y-accion-climatica",
    // },
  ];

  private mounted() {
    this.getBanners();
    this.getNoticias();
    this.getPopUp();
    this.autoScrollBanner();
  }

  private beforeDestroy() {
    if (this.bannerTimer) {
      window.clearTimeout(this.bannerTimer);
    }
  }

  private updated() {
    this.showSlides(this.slideIndex);
  }

  private getBanners() {
    this.$axios
      .get("slider")
      .then(res => {
        this.aBanners = res.data;
        for (let index = 0; index < this.aBanners.length; index++) {
          this.aBanners[index].imagen =
            process.env.VUE_APP_MEDIA_URL + "/" + this.aBanners[index].imagen;
          if (
            this.aBanners[index].imagen_mobile &&
            this.aBanners[index].imagen_mobile != ""
          ) {
            this.aBanners[index].imagen_mobile =
              process.env.VUE_APP_MEDIA_URL +
              "/" +
              this.aBanners[index].imagen_mobile;
          } else {
            this.aBanners[index].imagen_mobile = this.aBanners[index].imagen;
          }
          if (!this.aBanners[index].link) {
            this.aBanners[index].link = "#";
          }
        }
      })
      .catch((err: any) => {
        this.aBanners = [];
      });
  }

  private plusSlides(n) {
    this.showSlides((this.slideIndex += n));
  }

  private currentSlide(n) {
    this.showSlides((this.slideIndex = n));
  }

  private showSlides(n) {
    var i;
    var slides = document.getElementsByClassName("mySlides");
    var dots = document.getElementsByClassName("dot");
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    if (slides.length > 0) {
      for (i = 0; i < slides.length; i++) {
        (slides[i] as any).style.display = "none";
      }
      for (i = 0; i < dots.length; i++) {
        dots[i].className = dots[i].className.replace(" active", "");
      }

      (slides[this.slideIndex - 1] as any).style.display = "block";
      dots[this.slideIndex - 1].className += " active";
    }
  }

  private autoScrollBanner() {
    this.plusSlides(1);
    this.bannerTimer = window.setTimeout(this.autoScrollBanner, 5000);
  }

  private getNoticias() {
    this.$axios
      .get("noticias/general?pagina=1")
      .then(res => {
        // Tomar las primeras 4 noticias: ND (índice 0), N1 (1), N2 (2), N3 (3)
        this.noticias = res.data.noticias.slice(0, 4);
        for (let i = 0; i < this.noticias.length; i++) {
          this.noticias[i].id_slider = i + 1;
          if (
            this.noticias[i].fotos.image_intro &&
            this.noticias[i].fotos.image_intro != ""
          ) {
            this.noticias[i].fotos.image_intro =
              process.env.VUE_APP_MEDIA_URL +
              "/" +
              this.noticias[i].fotos.image_intro;
          } else {
            this.noticias[i].fotos.image_intro =
              process.env.VUE_APP_MEDIA_URL + "/Noticias/default_preview.jpg";
          }
        }
      })
      .catch((err: any) => {
        console.log(err);
      });
  }

  private getPopUp() {
    this.$axios
      .get("popup")
      .then(res => {
        this.popUp = res.data;

        if (!this.popUp || !this.popUp.imagen) {
          this.popUp = null;
          this.verPopUp = false;
          return;
        }

        if (this.isPopUpInCooldown(this.popUp)) {
          this.popUp = null;
          this.verPopUp = false;
          return;
        }

        if (!/^https?:\/\//.test(this.popUp.imagen)) {
          this.popUp.imagen =
            process.env.VUE_APP_MEDIA_URL +
            "/" +
            this.popUp.imagen.replace(/^\/+/, "");
        }

        this.savePopUpShownAt(this.popUp);
        this.verPopUp = true;
      })
      .catch(() => {
        this.popUp = null;
        this.verPopUp = false;
      });
  }

  private getPopUpStorageKey(popUp: any) {
    return "municipalidad:popup:shown-at:" + (popUp.id || popUp.imagen);
  }

  private isPopUpInCooldown(popUp: any) {
    try {
      const shownAt = Number(localStorage.getItem(this.getPopUpStorageKey(popUp)));
      const cooldownHours = Number(popUp.cooldown_hours || 24);

      if (!shownAt || !cooldownHours) {
        return false;
      }

      return Date.now() - shownAt < cooldownHours * 60 * 60 * 1000;
    } catch (error) {
      return false;
    }
  }

  private savePopUpShownAt(popUp: any) {
    try {
      localStorage.setItem(this.getPopUpStorageKey(popUp), Date.now().toString());
    } catch (error) {
      return;
    }
  }

  private clickPopUp() {
    if (this.popUp && this.popUp.url && this.popUp.url != "") {
      const url = /^https?:\/\//.test(this.popUp.url)
        ? this.popUp.url
        : "https://" + this.popUp.url;

      window.open(url, "_blank");
    }
  }

  private routerGo(name: string) {
    if (name && name != "") {
      if (this.$router.currentRoute.name == name) {
        this.$router.go(0);
      } else {
        this.$router.push({ name: name }).catch(err => {
          console.log(err);
        });
      }
    }
  }
  private toLink(item: any, target: any) {
    if (item && item != "") {
      window.open(item, target);
    } else {
      return;
    }
  }
  private goToTramites() {
    this.$router.push("/portal-servicios");
  }
}
